export default "__VITE_ASSET__17fc96db__"